/**
 * unflatten — expands a flat dot-path map into a nested object:
 *   { "login.headline": "Hi" }  ->  { login: { headline: "Hi" } }
 *
 * Used by emjo-login (Phase D) to feed operator override maps (stored flat,
 * `lang -> key -> text`) into Transloco's `setTranslation(..., {merge: true})`,
 * which expects nested translation objects. Story 25.5.
 */
export function unflatten(flat: Record<string, string>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [path, value] of Object.entries(flat ?? {})) {
    const parts = path.split('.');
    let node = out;
    for (let i = 0; i < parts.length - 1; i++) {
      const key = parts[i];
      const existing = node[key];
      if (typeof existing !== 'object' || existing === null) {
        node[key] = {};
      }
      node = node[key] as Record<string, unknown>;
    }
    node[parts[parts.length - 1]] = value;
  }
  return out;
}
